import React from "react";
import { FaEarthAmericas, FaSun, FaMoon } from "react-icons/fa6";

function CatalogTile({ item, handleButtonClick, type, meta }) {
  const { title, descr } = item;
  const displayName = type === "store" ? title : descr || title;

  const handleClick = () => {
    handleButtonClick(item);
  };

  const getIcon = () => {
    switch (type) {
      case "brand":
        return <FaSun />;
      case "category":
        return <FaMoon />;
      default:
        return <FaEarthAmericas />;
    }
  };

  return (
    <div className="catalog__tile" onClick={handleClick}>
      <span className="catalog__tile__icon">{getIcon()}</span>
      <span className="catalog__tile__name">{displayName}</span>
      {meta && <span className="catalog__tile__meta">{meta}</span>}
    </div>
  );
}

export default CatalogTile;
